import { ChangeDetectionStrategy, Component, inject, Input, OnChanges, SimpleChanges } from '@angular/core';
import { LocalDateAdapter } from '@core/localization/local-date-adapter';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { AsyncPipe, DatePipe } from '@angular/common';
import { UrlLoadReportPipe } from '../../../../shared/pipes/url-load-report/url-load-report.pipe';
import { PreLoaderModule } from '@ui/feedback/pre-loader/pre-loader.module';
import { NoMatchesComponent } from '@ui/feedback/no-matches/no-matches.component';
import { Load } from '@api/models/B2bService/Contract/load';
import { PaginatorComponent } from '@ui/table/paginator/paginator.component';
import { AbstractGridComponent } from '@ui/base/abstract-grid/abstract-grid.component';
import { IconBsComponent } from '@ui/elements/icon-bs/icon-bs.component';
import { BsIconTypes } from '@ui/elements/icon-bs/bs-icon-types';
import { TranslatePipe } from '@ngx-translate/core';


/**
 * Table List of downloads in b2b program
 */
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'b2b-table-uploads',
    templateUrl: './table-uploads.component.html',
    styleUrls: ['./table-uploads.component.scss'],
    imports: [
        MatTableModule,
        DatePipe,
        UrlLoadReportPipe,
        PreLoaderModule,
        NoMatchesComponent,
        MatSortModule,
        PaginatorComponent,
        AsyncPipe,
        IconBsComponent,
        TranslatePipe,
    ],
})
export class TableUploadsComponent extends AbstractGridComponent<Load> implements OnChanges {
    /**
     * Download history list
     */
    @Input()
    public uploads: Load[];

    readonly #dateFormatService: LocalDateAdapter = inject(LocalDateAdapter);
    public readonly calendarFormat: string = this.#dateFormatService.format.angular;

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes?.uploads?.currentValue) {
            this.displayEntities.data = changes?.uploads?.currentValue;
        }
    }

    protected readonly bsIconTypes: typeof BsIconTypes = BsIconTypes;
}
